import { Space, Policy, Puzzle } from "components/icons/generated";

import { LaunchPadExploreNextItemProps } from "./Item";

export const EXPLORE_NEXT_FEATURES: LaunchPadExploreNextItemProps[] = [
  {
    title: "Create a space",
    icon: Space,
    iconColor: "green",
    to: "/spaces?create-new",
    analyticsTitle: "Create Space Click",
  },
  {
    title: "Create a context",
    icon: Puzzle,
    iconColor: "yellow",
    to: "/new/context",
    analyticsTitle: "Create Context Click",
  },
  {
    title: "Create a policy",
    icon: Policy,
    iconColor: "fuchsia",
    to: "/policies?create-new",
    analyticsTitle: "Create Policy Click",
  },
];
